import { AlarmClock, CalendarCheck, CheckCircle2, Clock, PauseCircle, TimerOff, TrendingDown, TrendingUp } from "lucide-react";
import { useState } from "react";
import EmptyState from "../../components/EmptyState.jsx";
import StatCard from "../../components/StatCard.jsx";
import { useToast } from "../../context/ToastContext.jsx";
import { getDashboardMetric } from "../../firebase/firestore.js";
import { getDayName, getTodayKey } from "../../utils/date.js";

const METRICS = [
  { key: "scheduled", label: "Today scheduled", icon: CalendarCheck, tone: "blue" },
  { key: "inMarked", label: "IN marked", icon: Clock, tone: "green" },
  { key: "outCompleted", label: "OUT completed", icon: CheckCircle2, tone: "green" },
  { key: "pendingOut", label: "Pending OUT", icon: TimerOff, tone: "orange" },
  { key: "suspended", label: "Suspended", icon: PauseCircle, tone: "red" },
  { key: "lateEntries", label: "Late entries", icon: AlarmClock, tone: "orange" },
  { key: "earlyEntries", label: "Early entries", icon: TrendingDown, tone: "purple" },
  { key: "onTimeEntries", label: "On-time entries", icon: TrendingUp, tone: "blue" }
];

export default function AdminDashboard() {
  const [values, setValues] = useState({});
  const [loadingKey, setLoadingKey] = useState("");
  const { showToast } = useToast();

  async function loadMetric(metricKey) {
    setLoadingKey(metricKey);
    try {
      const value = await getDashboardMetric(metricKey, getTodayKey(), getDayName());
      setValues((current) => ({ ...current, [metricKey]: value }));
    } catch (error) {
      showToast(error.message || "Unable to load dashboard metric", "error");
    } finally {
      setLoadingKey("");
    }
  }

  async function loadAll() {
    for (const metric of METRICS) {
      await loadMetric(metric.key);
    }
  }

  return (
    <section className="admin-page">
      <div className="page-title-row">
        <div>
          <p>{getDayName()}, {getTodayKey()}</p>
          <h2>Dashboard</h2>
        </div>
        <button className="btn btn-primary" type="button" onClick={loadAll} disabled={Boolean(loadingKey)}>
          {loadingKey ? <span className="spinner" /> : null}
          Load All
        </button>
      </div>

      <div className="stats-grid dashboard-action-grid">
        {METRICS.map((metric) => {
          const Icon = metric.icon;
          const loaded = Object.prototype.hasOwnProperty.call(values, metric.key);
          return (
            <div className="metric-load-card" key={metric.key}>
              <StatCard label={metric.label} value={loaded ? values[metric.key] : "-"} icon={<Icon size={22} />} tone={metric.tone} />
              <button className="btn btn-ghost btn-wide" type="button" onClick={() => loadMetric(metric.key)} disabled={loadingKey === metric.key}>
                {loadingKey === metric.key ? <span className="spinner" /> : null}
                Load {metric.label}
              </button>
            </div>
          );
        })}
      </div>

      {!Object.keys(values).length ? (
        <EmptyState
          icon="📊"
          title="Choose what to load"
          text="Each button fetches only that dashboard detail to keep Firebase reads controlled."
        />
      ) : null}
    </section>
  );
}
